module.exports = __webpack_public_path__ + "img/cate-icon-2.3b05e42a.png";